module.exports = __webpack_public_path__ + "static/media/SWIRL-BNB.684ad1a4.png";